export default function( elem ) {
	return ( !elem.nextElementSibling );
}